import { AirdropSelectOfferPageTemplate } from "./template";
import { useAirdropSelectOfferPage } from "./logic";

export const AirdropSelectOfferPage = () : JSX.Element => {
    const props = useAirdropSelectOfferPage();

    return (
        <AirdropSelectOfferPageTemplate {...props}/>
    )
}